import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Tooltip from 'components/Tooltip';

import { t } from 'utils/language';

import type { DeliverableMediaStatus, SVGDynamicIconCustomColor } from 'types';

type Props = {
  isForBrand?: boolean,
  requiresApproval?: boolean,
  status: DeliverableMediaStatus
};

const ICONS: Record<string, { name: string, color: SVGDynamicIconCustomColor }> = {
  incomplete: {
    name: 'exclamation-inside-circle-white-bg-custom-fg',
    color: 'red'
  },
  pending: {
    name: 'three-dots-inside-circle-custom-fg',
    color: 'orange'
  },
  complete: {
    name: 'checkmark-inside-circle-custom-fg',
    color: 'primary'
  }
};

class DeliverableMediaStatusMark extends React.PureComponent<Props> {
  render() {
    const { status, isForBrand, requiresApproval } = this.props;

    if (status === 'ok') {
      return null;
    }

    let tooltip: string | null = null;

    if (requiresApproval) {
      tooltip = t(`deliverable_approval.status_mark.${status}_for_${isForBrand ? 'brand' : 'influencer'}`);
    }

    const icon = (
      <SVGDynamicIcon
        name={ICONS[status].name}
        width={16}
        height={16}
        customColor={ICONS[status].color}
        data={{ qa: `deliverable-media__svg-${status}` }}
      />
    );

    return (
      <section className="deliverable-media-status-mark">
        {
          tooltip ?
            <Tooltip
              key={status}
              message={tooltip}
            >
              {icon}
            </Tooltip> :
            icon
        }
      </section>
    );
  }
}

export default DeliverableMediaStatusMark;
